module.exports = __webpack_public_path__ + "static/media/activity-icon.e8ba5b7d.svg";